import React from "react";
import "./Contact.css";
import { Col, Container, Row, Card } from "react-bootstrap";

export const Contact = () => {
  return (
    <Container className="contact" id="contact">
      <Card body className="contact-card-body">
        <Row>
          <Col>
            <h1 className="contact-h1-mini">Kontakt</h1>
            <h1 className="contact-h1">Kontakt z nami</h1>
            <p>dwojka.net Usługi informatyczne</p>
            <p>
              ul. Bzowa 3/2
              <br />
              80-376 Gdańsk
              <br />
              NIP: 8471004220
              <br />
            </p>
          </Col>
        </Row>
        <Row className="justify-content-center contact-address">
          <Col className="contact-address-tel d-flex align-items-center">
            +48 691 166 622
          </Col>
          <Col className="contact-address-mail d-flex align-items-center">
            kontakt@strefadlaedukacji.pl
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default Contact;
